export default {
    /****** String helper *******
     * @function isEmptyStr
     * @function newLineToBr
     * @function formatNum
     * @function removeEmojis
     * @function contactNumberFormat
     * @function isNationalIdCard
     * @function isJson
     ****************************/
    isEmptyStr: function(str) {
        return (str === null || str === undefined || str === '');
    },
    newLineToBr: function(str) {
        if(!str) return '';
        return str.replace(/\n/g, "<br />").trim();
    },
    formatNum: function(n, d) {
        let str = (n || 0).toFixed(d);
        let x = str.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },
    removeEmojis: function(string) {
        let regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        return string.replace(regex, '');
    },
    contactNumberFormat: function(strContactNumber, delimeter) {
        if (strContactNumber.length < 10) {
            return strContactNumber;
        }

        let n1 = strContactNumber.substr(0, 3);
        let n2 = strContactNumber.substr(3, 3);
        let n3 = strContactNumber.substr(6);

        return `${n1}${delimeter}${n2}${delimeter}${n3}`;
    },
    isNationalIdCard: function (id) {
        if (id.length != 13) {
            return false;
        }

        let sum = 0;
        for (let i=0; i < 12; i++) {
            sum += parseFloat(id.charAt(i)) * (13 - i);
        }

        return (11 - sum % 11) % 10 != parseFloat(id.charAt(12)) ? false : true;
    },
    isJson: function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }

        return true;
    },

    /******* Bzbs utility ********
     * @function shuffleToken
     * @function reShuffleToken
     * @function getBrowserVersion
     * @function getOSName
     * @function normalObject
     * @function stringFormat
     * @function cleanObjectNullKey
     * @function cleanObjectEmptyStr
     * @function isEmptyObject
     * @function log
     * @function logJson
     * @function scrollTop
     * @function disableZoomIos
     * @function getUUID
     * @function getWebUrl
     * @function arrayRemoveAt
     * @function toJsonStr
     * @function jsonParse
     * @function isNumber
     * @function parseInt
     * @function isFunction
     *****************************/
    shuffleToken: function(bzbtoken) {
        return bzbtoken.substring(bzbtoken.length - 5, bzbtoken.length) + bzbtoken.substring(1, bzbtoken.length - 5);
    },
    reShuffleToken: function(token) {
        let head = token.substr(0, 5);
        let tail = token.substr(5);
        let newToken = '.' + tail + head;
        return newToken;
    },
    getBrowserVersion: function() {
        const userAgent = navigator.userAgent;
        let version = '';

        if (userAgent.indexOf('Edge') !== -1) {
            version = userAgent.substring(userAgent.indexOf('Edge/') + 5);
        } else if (userAgent.indexOf('Chrome') !== -1) {
            version = userAgent.substring(userAgent.indexOf('Chrome/') + 7);
        } else if (userAgent.indexOf('Safari') !== -1) {
            version = userAgent.substring(userAgent.indexOf('Version/') + 8);
        } else if (userAgent.indexOf('Firefox') !== -1) {
            version = userAgent.substring(userAgent.indexOf('Firefox/') + 8);
        } else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1) {
            version = userAgent.substring(userAgent.indexOf('rv:') + 3);
        }

        if (version.indexOf(';') !== -1) {
            version = version.substring(0, version.indexOf(';'));
        }

        return version;
    },
    getOSName: function() {
        let userAgent = navigator.userAgent;
        let OSName = "Unknown OS";

        if (userAgent.indexOf("Win") != -1) OSName = "Windows";
        if (userAgent.indexOf("Mac") != -1) OSName = "MacOS";
        if (userAgent.indexOf("X11") != -1) OSName = "UNIX";
        if (userAgent.indexOf("Linux") != -1) OSName = "Linux";

        return OSName;
    },
    normalObject: function(obj) {
        if (!obj) {
            return null;
        }
        let json = JSON.stringify(obj);
        let normalObj = JSON.parse(json);
        return normalObj;
    },
    cleanObjectNullKey: function (object) {
        let cleanObject = {};
        for (let i in object) {
            if (object[i] != null) {
                cleanObject[i] = object[i];
            }
        }
        return cleanObject;
    },
    cleanObjectEmptyStr: function(object) {
        let cleanObject = {};
        for (let i in object) {
            if (!this.isEmptyStr(object[i])) {
                cleanObject[i] = object[i];
            }
        }
        return cleanObject;
    },
    stringFormat: function () {
        let s = arguments[0];
        if (this.isEmptyStr(s)) {
            return '';
        }

        for (let i = 0; i < arguments.length - 1; i += 1) {
            let reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    },
    isEmptyObject: function(obj) {
        if (obj == null || obj == '') {
            return true;
        }

        let str = JSON.stringify(obj);

        return str == '{}' || str == '[]' ? true : false;
    },
    log: function(text1, text2) {
        if (text2) {
            console.log(text1, this.normalObject(text2));
        } else {
            if (text1 == null) {
                console.log(text1);
                return;
            }
            console.log(this.normalObject(text1));
        }
    },
    /**
     * @param {Object|Array} obj
     * @param {String} color red green blue purple
     */
    logJson: function(obj, color) {
        if (obj == null) {
            console.log(obj);
            return;
        }
        let json = JSON.stringify(obj, null, 2);
        let colorCode = null;
        switch (color) {
            case 'red':
                colorCode = "\x1b[31m%s\x1b[0m";
                break;
            case 'green':
                colorCode = "\x1b[32m%s\x1b[0m";
                break;
            case 'blue':
                colorCode = "\x1b[34m%s\x1b[0m";
                break;
            case 'purple':
                colorCode = "\x1b[35m%s\x1b[0m";
                break;
            default:
                colorCode = null;
        }

        if (colorCode != null) {
            console.log(colorCode, json);
        } else {
            console.log(json);
        }
    },
    scrollTop: function(smoot) {
        let config = { top: 0 };
        if (smoot) {
            config.behavior = 'smooth';
        }
        window.scrollTo(config);
    },
    disableZoomIos: function() {
        //https://stackoverflow.com/questions/37808180/disable-viewport-zooming-ios-10-safari

        document.documentElement.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);

        document.addEventListener('touchmove', function (event) {
            event = event.originalEvent || event;
            if (event.scale > 1) {
                event.preventDefault();
            }
        }, false);

        document.documentElement.addEventListener('gesturestart', function (event) {
            event.preventDefault();
        }, false);
    },
    getUUID: function() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    },
    getWebUrl: function(path) {
        let protocol = window.location.protocol + '//';
        let host = window.location.hostname + '/';
        return protocol + host + path;
    },
    arrayRemoveAt: function(array, index) {
        if (array.length > index) {
            return array.splice(index, 1);
        }
        return array;
    },
    toJsonStr: function(obj) {
        if (obj) {
            try {
                let json = JSON.stringify(obj);
                return json;
            } catch (e) {
                return null;
            }
        } else {
            return null;
        }
    },
    jsonParse: function(jsonStr) {
        if (!this.isEmptyStr(jsonStr)) {
            try {
                let data = JSON.parse(jsonStr);
                return data;
            } catch (e) {
                return null;
            }
        }
        return null;
    },
    isNumber: function(num) {
        return !isNaN(num);
    },
    strToInt: function(str, defaultValue) {
        if (this.isNumber(str)) {
            return parseInt(str);
        } else if (defaultValue != null) {
            return defaultValue;
        } else {
            return 0;
        }
    },
    isFunction: function(fn) {
        return (typeof fn === 'function');
    },

    /********* File **********
     * @function isFileTypeExcel
     * @function isFileTypeJpg
     * @function isFileTypePng
     * @function isFileTypeSvg
     * @function isFileTypeImage
     * @function isFileTypeZip
     * @function isFileTypePdf
     *************************/

    /**
     * @param {string} fileType
     */
    isFileTypeExcel: function(fileType) {
        let typeList = [
            'application/excel',
            'application/vnd.ms-excel',
            'application/vnd.msexcel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },

    /**
     * @param {string} fileType
     */
    isFileTypeJpg: function(fileType) {
        let typeList = [
            'image/jpeg',
            'image/jpg',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },

    /**
     * @param {string} fileType
     */
    isFileTypePng: function(fileType) {
        let typeList = [
            'image/png',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },

    /**
     * @param {string} fileType
     */
    isFileTypeSvg: function(fileType) {
        let typeList = [
            'image/svg+xml',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },

    /**
     * @param {string} fileType
     */
    isFileTypeImage: function(fileType) {
        return this.isFileTypeJpg(fileType) || this.isFileTypePng(fileType) || this.isFileTypeSvg();
    },

    /**
     * @param {string} fileType
     */
    isFileTypeZip: function(fileType) {
        let typeList = [
            'application/x-zip-compressed',
            'application/zip',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },

    /**
     * @param {string} fileType
     */
    isFileTypePdf: function(fileType) {
        let typeList = [
            'application/pdf',
        ];
        let rs = typeList.find((item) => {
            return fileType == item;
        });
        return rs != null;
    },
    // example https://www.youtube.com/watch?v=xxHAADKqG1A&list=RDxxHAADKqG1A&start_radio=1
    getAllUrlParams:function(url) {

        // get query string from url (optional) or window
        let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

        // we'll store the parameters here
        let obj = {};

        // if query string exists
        if (queryString) {

          // stuff after # is not part of query string, so get rid of it
          queryString = queryString.split('#')[0];

          // split our query string into its component parts
          let arr = queryString.split('&');

          for (let value of arr) {
            // separate the keys and the values
            let a = value.split('=');

            // set parameter name and value (use 'true' if empty)
            let paramName = a[0];
            let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            // if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

              // create key if it doesn't exist
              let key = paramName.replace(/\[(\d+)?\]/, '');
              if (!obj[key]) obj[key] = [];

              // if it's an indexed array e.g. colors[2]
              if (paramName.match(/\[\d+\]$/)) {
                // get the index value and add the entry at the appropriate position
                let index = /\[(\d+)\]/.exec(paramName)[1];
                obj[key][index] = paramValue;
              } else {
                // otherwise add the value to the end of the array
                obj[key].push(paramValue);
              }
            } else {
              // we're dealing with a string
              if (!obj[paramName]) {
                // if it doesn't exist, create property
                obj[paramName] = paramValue;
              } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                // if property does exist and it's a string, convert it to an array
                obj[paramName] = [obj[paramName]];
                obj[paramName].push(paramValue);
              } else {
                // otherwise add the property
                obj[paramName].push(paramValue);
              }
            }
          }
        }

        return obj;
      }
};
